import React from "react";
import { ThemeProvider } from "@mui/material";
import { useSelector } from "react-redux";
import Application from "./application/Application";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import lightTheme from "./utils/themes/lightTheme";
import darkTheme from "./utils/themes/darkTheme";

const themes = [darkTheme, lightTheme];

export default function App() {
  const appState = useSelector((state) => state?.application);

  const themeIndex = appState?.themeIndex ?? 0;
  const theme = themes[themeIndex] || darkTheme;

  return (
    <ThemeProvider theme={theme}>
      <Application />
    </ThemeProvider>
  );
}
